import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VersioningService {
  constructor(private httpClient: HttpClient) {}

  getLatestVersion(): Observable<any> {
    return this.httpClient.get<any>('/settings.json?d=' + new Date().getTime());
  }

  getCurrentVersion(): string {
    return (<HTMLInputElement>window.document.getElementById('versionHidden')).value;
  }
}

